var React = require('react');

function CaretRight (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"className":"svg-stroke","fill":"none","stroke":"#FFF","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.079","points":"200.5 22.5 195 28.5 189.5 22.5","transform":"rotate(-90 90 111.5)"}));
}

CaretRight.defaultProps = {"width":"8","height":"13","viewBox":"0 1 8 13"};

module.exports = CaretRight;

CaretRight.default = CaretRight;
